// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Flutterwave from "vue-flutterwave";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import App from "./App";
import router from "./router";
import store from "./store";
import InstantSearch from 'vue-instantsearch';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(InstantSearch);
Vue.use(Flutterwave, {
  publicKey: "FLWPUBK-86246bf1df8332fb48eae8fb8020a0ac-X"
});
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueMeta from 'vue-meta'
 
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  vuetify,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js